import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
  const element = document.scrollingElement || document.documentElement;
  element.scrollTop = 0;
}, [pathname]);

  return null;
}
